import { Http } from 'services/http';
import { API_CHAT_URL } from 'consts/common.const';

export interface RequestPin {
  conversation_id: string;
  user_id: string;
  pin_chat: boolean;
}

export const updatePinChat = (data: RequestPin) => {
  return Http.request({
    method: 'PUT',
    url: `${API_CHAT_URL}/conversation/toggle-pin`,
    body: data,
  });
};
